module.exports = __webpack_public_path__ + "img/how_electric_motor_work_splash.267336aa.jpg";